import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-table-number-dialog',
  standalone: false,
  templateUrl: './table-number-dialog.component.html',
  styleUrl: './table-number-dialog.component.scss',
})
export class TableNumberDialogComponent {


	ui: any = {}
	constructor(
		public dialogRef: MatDialogRef<TableNumberDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {
		const val: string = ''
		this.ui = {
			connectOptions: {
				type: 'code',
				minLength: 1,
				maxLength: 20,
				showApply: false,
				showValue: false,
				amount: val,
				amountText: val
			},
			connectValue: val,
			connectValid: false,

			authValue: '',
			authValid: false
		}
	}

	onTableNumberChange(val) {
		if (!val) return;
		let n = val.amountText.length;
		this.ui.connectValue = val.amountText;
		this.ui.connectValid = this.ui.connectValue.length >= 1;
	}

	close() {
		this.dialogRef.close();
	}
	applyTakeAway() {
		this.dialogRef.close({
			mode: 'takeaway',
		});
	}
	applyEatin() {
		this.dialogRef.close({
			mode: 'eatin',
			tableNumber: this.ui.connectValue,
		});
	}


}
